module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lmnGb"))).then(() => parcelRequire('1iHdE'));